export default __webpack_public_path__ + "static/media/07_popis-pokaceneho-kmene.08f95b21.jpg";